import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "constants/UserRoles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const breadcrumbsStatic = [{
	name: 'Idle Tasks Admin',
	url: '/managers/idle_tasks_admin',
	icon: 'users',
}];

const all_roles = [30];

class IdleTasksAdmin extends Framework.Components.View {

	constructor(props) {
		super(props, UserRoles[all_roles.includes(props.main_role) ? props.main_role : 30]);
		this.state.tab = UserRoles[all_roles.includes(props.main_role) ? props.main_role : 30];
	}

	componentDidMount() {
		this.setState({static_roles: this.props.main_role === 10 ? all_roles : this.props.roles.filter((role) => role === 90 || all_roles.includes(role)).sort((a, b) => a - b)})
	}

	refreshPage = () => {
		this.setState({
			key: Math.random(),
			refresh: !this.state.refresh
		});
	};

	render() {
		let {history} = this.props;
		let {static_roles} = this.state;
		if (!static_roles) {
			return null;
		}

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					<Button data-cy="add-customer" onClick={this.toggle('modalTaskAdd')} size={"sm"} color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Add Idle Task
					</Button>

					<Button onClick={async () => {
						await this.refreshPage();
					}} size={"sm"} color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Refresh Data
					</Button>
				</Framework.Components.PageBar>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={`New Idle Task For ${this.state.tab} Group`}
					object={Objects.IdleTask}
					toggle={this.state.modalTaskAdd}
					reportClose={this.reportClose('modalTaskAdd')}
					afterSave={() => this.refreshPage()}
					hideGoTo={true}
					objectProps={{allowed_roles: all_roles}}
				/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					{all_roles.map((role) => role !== 90 && <Tab key={Math.random()} label={UserRoles[role]} value={UserRoles[role].replace(' ', '')}/>)}
				</Tabs>


				<Collections.IdleTasks
					key={this.state.key}
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					filter={this.state.tab}
					handleTabChange={this.handleTabChange}
					user={this.props.rootState.user}
					isAtLeastManager={this.props.main_role <= 20}
					all_roles={all_roles}
				/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(IdleTasksAdmin);

